import { View, Switch } from "../base";

export type PrivacySettingsFormData = {
  id?: string;
  agentId?: string;
  redactionEnabled?: boolean;
  tracingEnabled?: boolean;
};

type PrivacySettingsFormProps = {
  config: PrivacySettingsFormData;
  onChange: (key: string) => (value: unknown) => void;
  organizationId: string;
  isAdmin?: boolean;
};

export const PrivacySettingsForm = ({ config, onChange, organizationId, isAdmin }: PrivacySettingsFormProps) => {
  const onChangeRedaction = (value: string | null) => {
    const newRedactionEnabled = value === "true";
    onChange("redactionEnabled")(newRedactionEnabled);
  };

  const onChangeTracing = (value: string | null) => {
    const newTracingEnabled = value === "true";
    onChange("tracingEnabled")(newTracingEnabled);
  };

  return (
    <View className="space-y-6">
      <View className="space-y-4">
        <Switch
          label="Data Redaction"
          labelClassName="!w-full"
          className="!w-full"
          tooltip="Enable automatic redaction of sensitive information from call transcripts and logs."
          value={config.redactionEnabled ? "true" : "false"}
          onChange={onChangeRedaction}
          options={[
            { label: "Disabled", value: "false" },
            { label: "Enabled", value: "true" },
          ]}
        />
        <Switch
          label="Tracing"
          labelClassName="!w-full"
          className="!w-full"
          tooltip="Enable detailed tracing of LLM calls and agent workflow for debugging and analysis."
          value={config.tracingEnabled ? "true" : "false"}
          onChange={onChangeTracing}
          options={[
            { label: "Disabled", value: "false" },
            { label: "Enabled", value: "true" },
          ]}
        />
      </View>
    </View>
  );
};
